import { create } from "zustand";

/**
 * 1. Visit webapp page and complete sign-in flow
 * 2. Get a session endpoint by calling SessionService - CreateBrowser API or from cached session endpoint
 * 3. Display webapp loading definite/indefinite progress spinner
 * 4. AS2 session started - not in-session script/Chrome browser. It will show toolbar and in-session wallpaper loading image
 * 5. Launch Chrome browser. WSB portal is fully ready to use.
 *
 * All the timestamp are logging the first time event timestamp.
 */
interface UseSessionLaunchMetricStoreStore {
    sessionEndpointCreatedTimestamp: number | null;
    cachedSessionEndpointLoadedTimestamp: number | null;
    as2SessionReadyTimestamp: number | null;
    setSessionEndpointCreatedTimestampIfEmpty: (timestamp?: number) => void;
    setCachedSessionEndpointLoadedTimestampIfEmpty: (
        timestamp?: number
    ) => void;
    setAs2SessionReadyTimestampIfEmpty: (timestamp?: number) => void;
}

export const useSessionLaunchMetricStore =
    create<UseSessionLaunchMetricStoreStore>((set, get) => ({
        sessionEndpointCreatedTimestamp: null,
        cachedSessionEndpointLoadedTimestamp: null,
        as2SessionReadyTimestamp: null,
        setSessionEndpointCreatedTimestampIfEmpty: (timestamp) => {
            set((state) => {
                if (get().sessionEndpointCreatedTimestamp != null) {
                    return { ...state };
                }
                return {
                    ...state,
                    sessionEndpointCreatedTimestamp: timestamp ?? Date.now(),
                };
            });
        },
        setCachedSessionEndpointLoadedTimestampIfEmpty: (timestamp) => {
            set((state) => {
                if (get().cachedSessionEndpointLoadedTimestamp != null) {
                    return { ...state };
                }
                return {
                    ...state,
                    cachedSessionEndpointLoadedTimestamp:
                        timestamp ?? Date.now(),
                };
            });
        },
        setAs2SessionReadyTimestampIfEmpty: (timestamp) => {
            set((state) => {
                if (get().as2SessionReadyTimestamp != null) {
                    return { ...state };
                }
                return {
                    ...state,
                    as2SessionReadyTimestamp: timestamp ?? Date.now(),
                };
            });
        },
    }));
